import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, UrlSegment, Router } from '@angular/router';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../services/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class LoggedInGuard  {
  constructor(
    public auth: AuthenticationService,
    public router: Router,
  ) {}

  private async checkIfLoggedAndReturn(returnUrl?: string) {
    const loggedIn = !!this.auth.getCurrentUser();

    if (!loggedIn) {
      this.router.navigate(['/']);
    }

    return loggedIn;
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkIfLoggedAndReturn(next.url[0].path);
  }

  canLoad(route: any, segments: UrlSegment[]): boolean | Observable<boolean> | Promise<boolean> {
    return this.checkIfLoggedAndReturn(route.path);
  }
}
